const Bullhorn = (
    <g>
        <path d="m9.02896 12.9998h-3.569l.714 3.413c.082.393.312.73.648.949.247.161.529.244.816.244.104 0 .209-.011.313-.033l.489-.104c.809-.171 1.328-.968 1.157-1.778l-.569-2.692z" />
        <path d="m16.185 5.91179c-.117.095-.185.237-.185.388v2.399c0 .151.068.293.185.388s.271.132.418.101c.822-.173 1.397-.868 1.397-1.689s-.575-1.516-1.397-1.689c-.147-.031-.301.006-.418.101z" />
        <path d="m5 3.5c-2.206 0-4 1.794-4 4s1.794 4 4 4z" />
        <path d="m14.493 1.04088c-.303-.104002-.638-.004-.835.25-.476.615-2.062 2.209-3.657 2.209h-3.50002v8.00002h3.50002c1.911 0 3.641 2.188 3.658 2.21.145.186.365.289.592.289.082 0 .164-.013.244-.041.303-.104.506-.388.506-.708v-11.50002c0-.321-.204-.606-.507-.709z" />
    </g>
);

export { Bullhorn };
